import http from "../plugins/Axios";
import { makerPagination } from "@/utils/pureFunctions";

export default {
  actions: {
    async getProductTypes(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("product-type/items", {
          params,
        });
        return {
          data: data.map((item, index) => {
            item.index = index + 1;
            return item;
          }),
          total,
          lastPage:
            query && query.limit
              ? makerPagination({ limit: query.limit, total }).lastPage
              : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getProductOfficeType(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("product-type/list", {
          params,
        });
        return {
          data: data.map((item, index) => {
            item.index = index + 1;
            return item;
          }),
          total,
          lastPage:
            query && query.limit
              ? makerPagination({ limit: query.limit, total }).lastPage
              : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
